import { Link } from "react-router-dom";
import { Mail, MessageCircle, PackageSearch, RotateCcw } from "lucide-react";

export default function ContactPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-8" data-testid="contact-page">
      <p className="eyebrow mb-2">Contact</p>
      <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Talk to us</h1>
      <p className="mt-3 text-sm leading-relaxed text-slate-400">
        Questions about an order, a return, or a product? We typically reply within one business day.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <div className="card-surface flex items-center gap-4 p-6">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400/15 text-amber-300">
            <Mail size={22} />
          </span>
          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-slate-500">Support</p>
            <a href="mailto:support@trenddropmedia.com" data-testid="contact-email-link" className="font-heading text-base font-semibold text-amber-400 hover:text-amber-300">
              support@trenddropmedia.com
            </a>
            <p className="mt-0.5 text-[11px] text-slate-500">Orders, returns, product questions</p>
          </div>
        </div>
        <div className="card-surface flex items-center gap-4 p-6">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400/15 text-amber-300">
            <Mail size={22} />
          </span>
          <div>
            <p className="text-xs font-mono uppercase tracking-widest text-slate-500">Billing</p>
            <a href="mailto:billing@trenddropmedia.com" data-testid="contact-billing-link" className="font-heading text-base font-semibold text-amber-400 hover:text-amber-300">
              billing@trenddropmedia.com
            </a>
            <p className="mt-0.5 text-[11px] text-slate-500">Refunds, invoices, payment issues</p>
          </div>
        </div>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <div className="card-surface p-5">
          <MessageCircle size={18} className="text-amber-400" />
          <p className="mt-2 font-heading text-sm font-semibold text-white">Instant answers</p>
          <p className="mt-1 text-xs text-slate-400">Our AI assistant answers order, shipping and returns questions 24/7 — bottom right of any page.</p>
        </div>
        <Link to="/track" className="card-surface block p-5 transition-colors hover:border-amber-400/40" data-testid="contact-track-link">
          <PackageSearch size={18} className="text-amber-400" />
          <p className="mt-2 font-heading text-sm font-semibold text-white">Track an order</p>
          <p className="mt-1 text-xs text-slate-400">Live status and tracking number for any order.</p>
        </Link>
        <Link to="/returns" className="card-surface block p-5 transition-colors hover:border-amber-400/40" data-testid="contact-returns-link">
          <RotateCcw size={18} className="text-amber-400" />
          <p className="mt-2 font-heading text-sm font-semibold text-white">Start a return</p>
          <p className="mt-1 text-xs text-slate-400">30-day window · refund to your original payment method.</p>
        </Link>
      </div>
    </div>
  );
}
